<div [formGroup]="form">
    <div formArrayName="limits">
        @for (row of limits.controls; track row; let i = $index) {
        <div [formGroupName]="i" class="row g-2 align-items-end mb-2">
            <div class="col-6 col-md-2">
                @if (i === 0) {
                <label class="form-label small text-muted">Edad desde</label>
                }
                <input type="text" formControlName="ageFrom" class="form-control form-control-sm" mask="0*">
            </div>
            <div class="col-6 col-md-2">
                @if (i === 0) {
                <label class="form-label small text-muted">Edad hasta</label>
                }
                <input type="text" formControlName="ageTo" class="form-control form-control-sm" mask="0*">
            </div>
            <div class="col-4 col-md-2">
                @if (i === 0) {
                <label class="form-label small text-muted">Moneda</label>
                }
                <select formControlName="currency" class="form-select form-select-sm">
                    @for (c of currencies; track c) {
                    <option [value]="c">{{ c }}</option>
                    }
                </select>
            </div>
            <div class="col-6 col-md-4">
                @if (i === 0) {
                <label class="form-label small text-muted">Suma asegurada máxima</label>
                }
                <input type="text" formControlName="maxAmount" class="form-control form-control-sm"
                    mask="separator.2" thousandSeparator=",">
            </div>
            <div class="col-2 col-md-2">
                <button type="button" class="btn btn-outline-danger btn-sm" (click)="remove(i)" [disabled]="disabled"
                    title="Eliminar rango">
                    <span class="material-symbols-outlined" style="font-size: 18px;">delete</span>
                </button>
            </div>
        </div>
        }
    </div>
    <button type="button" class="btn btn-sm btn-outline-colonial" (click)="add()" [disabled]="disabled">
        <span class="material-symbols-outlined" style="font-size: 16px; vertical-align: middle;">add</span>
        Agregar rango de edad
    </button>
    <div class="form-text">Aplica a la cobertura principal según la edad del asegurado principal y la moneda de la
        cotización.</div>
</div>
